/* The shortlist stores catalogue references only, never personal form fields. */
(function (global) {
  'use strict';
  const KEY = 'yangluu-shortlist-v1';
  const TTL = 7 * 24 * 60 * 60 * 1000;
  const LIMIT = 30;
  const modes = ['wholesale', 'dropshipping', 'retail'];
  function create(storage, origin, now = Date.now) {
    let state = { mode: 'wholesale', items: [] };
    let persistent = true;
    const quantity = value => Math.min(9999, Math.max(1, Math.floor(Number(value) || 1)));
    function clean(item) {
      if (!item || typeof item !== 'object' || !/^\d+$/.test(String(item.id))) return null;
      if (typeof item.handle !== 'string' || !/^[a-z0-9][a-z0-9-]*$/.test(item.handle)) return null;
      if (typeof item.title !== 'string' || !item.title.trim()) return null;
      try {
        const url = new URL(item.url, origin);
        if (url.origin !== origin || !url.pathname.endsWith('/products/' + item.handle)) return null;
        let image = '';
        if (typeof item.image === 'string' && item.image) {
          const media = new URL(item.image, origin);
          if (media.protocol === 'https:' && (media.origin === origin || media.hostname === 'cdn.shopify.com')) image = media.href;
        }
        return { id: String(item.id), handle: item.handle, title: item.title.slice(0, 250), url: url.pathname, image, qty: quantity(item.qty), photo: Math.min(250, Math.max(1, Math.floor(Number(item.photo) || 1))) };
      } catch (_) { return null; }
    }
    function load() {
      try {
        const raw = JSON.parse(storage.getItem(KEY) || 'null');
        persistent = true;
        if (!raw || raw.version !== 1 || !Number.isFinite(raw.savedAt) || raw.savedAt > now() + 60000 || now() - raw.savedAt > TTL) return;
        const seen = new Set();
        state.items = (Array.isArray(raw.items) ? raw.items : []).map(clean).filter(item => {
          if (!item || seen.has(item.id)) return false;
          seen.add(item.id); return true;
        }).slice(0, LIMIT);
        state.mode = modes.includes(raw.mode) ? raw.mode : 'wholesale';
      } catch (_) { persistent = false; }
    }
    function save() {
      try { storage.setItem(KEY, JSON.stringify({ ...state, version: 1, savedAt: now() })); persistent = true; }
      catch (_) { persistent = false; }
    }
    load();
    return {
      snapshot: () => JSON.parse(JSON.stringify({ ...state, persistent })),
      add(input) {
        const item = clean(input);
        if (!item) return 'invalid';
        if (state.items.some(row => row.id === item.id)) return 'existing';
        if (state.items.length >= LIMIT) return 'full';
        state.items.push(item); save(); return 'added';
      },
      remove(id) { state.items = state.items.filter(item => item.id !== String(id)); save(); },
      clear() { state.items = []; save(); },
      setQuantity(id, value) { const item = state.items.find(row => row.id === String(id)); if (item) { item.qty = quantity(value); save(); } },
      setPhoto(id, photo, image) { const index = state.items.findIndex(row => row.id === String(id)); if (index >= 0) { state.items[index] = clean({ ...state.items[index], photo, image: image || state.items[index].image }); save(); } },
      setMode(mode) { if (modes.includes(mode)) { state.mode = mode; save(); } },
      reload() { const previous = state; state = { mode: 'wholesale', items: [] }; load(); if (!persistent) state = previous; }
    };
  }
  function rowsText(items, origin, photoLabel = 'Photo') {
    return items.map((item, i) => `${i + 1}. ${item.title} × ${item.qty}\n${new URL(item.url, origin).href}` + (item.photo ? `\n${photoLabel} ${item.photo}` + (item.image ? `: ${item.image}` : '') : '')).join('\n');
  }
  function message({ intro, typeLabel, itemsLabel, mode, items, origin, fields = [], labels = {} }) {
    const parts = [intro, `${typeLabel}: ${mode}`];
    if (items.length) {
      parts.push(`${itemsLabel}:\n${rowsText(items, origin, labels.photo)}`);
      parts.push(`${labels.total || 'Total requested pieces'}: ${items.reduce((sum, item) => sum + item.qty, 0)}`);
    }
    fields.forEach(([label, value]) => { const cleaned = String(value || '').trim(); if (cleaned) parts.push(`${label}: ${cleaned}`); });
    return parts.join('\n');
  }
  global.YangluuSelection = { create, key: KEY, limit: LIMIT, rowsText, message };
})(typeof window === 'undefined' ? globalThis : window);
